/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDoorCheckOut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h12v18h6v2H2v-2h2zm2 18h8V4H6zM18.78 5.375 23.28 11l-4.5 5.625-1.56-1.25L20.72 11l-3.5-4.375zM12 13h-2v-2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDoorCheckOut as DoorCheckOut };
